import { useEffect } from 'react';
import { settingsService } from '../../../services/settingsService';
import { useSnackbar } from '../../../components/common/Snackbar';

/**
 * Hook to manage notification preferences loading for Settings page
 * @param {Object} params - Hook parameters
 * @param {Object} params.user - Current user object
 * @param {Function} params.setNotificationSettings - Setter for notification settings
 * @param {Function} params.setIsLoadingPreferences - Setter for loading state
 * @returns {void}
 */
export const useSettingsPageData = ({ user, setNotificationSettings, setIsLoadingPreferences }) => {
  const { showSnackbar } = useSnackbar();

  // Load notification preferences on mount
  useEffect(() => {
    const loadNotificationPreferences = async () => {
      setIsLoadingPreferences(true);
      try {
        const preferences = await settingsService.getNotificationPreferences();
        if (preferences && preferences.emailNotifications !== undefined) {
          setNotificationSettings((prev) => ({
            ...prev,
            emailNotifications: preferences.emailNotifications,
          }));
        }
      } catch (error) {
        // If endpoint doesn't exist or fails, use default values from user object or true
        // console.log('Could not load notification preferences, using defaults:', error);

        // Try to get from user object if available
        if (user?.emailNotifications !== undefined) {
          setNotificationSettings((prev) => ({
            ...prev,
            emailNotifications: user.emailNotifications,
          }));
        }
      } finally {
        setIsLoadingPreferences(false);
      }
    };

    loadNotificationPreferences();
  }, [user, setNotificationSettings, setIsLoadingPreferences]);
};
